<template>
  <div class="bg-white">
    <div
      class="container"
      :class="screen === 'mobile' ? '' : 'padding-right-80px padding-left-80px'"
    >
      <div
        class="bg-white mb-3"
        :class="
          screen === 'mobile'
            ? 'columns is-multiline has-margin-bottom-15'
              ? 'desktop'
              : 'columns is-centered is-multiline has-margin-left-55 has-margin-right-55 has-margin-top-5'
            : 'columns is-centered is-multiline has-margin-top-5'
        "
      >
        <div
          class="column is-9 has-border-top-width-5 is-flex is-flex-direction-column"
          :class="screen === 'mobile' ? 'pa-2' : ''"
        >
          <div class="card rounded-10 has-border-width-5 has-margin-5">
            <job-detail></job-detail>
          </div>
          <div class="is-flex justify-center">
            <dfp-slot
              id="div-gpt-ad-1715312892245-0"
              :path="'/35754210/RJP-MB'"
              mappingJobSearch
              :size="[
                [728, 90],
                [320, 100]
              ]"
            />
          </div>
        </div>
        <div
          class="column is-3 is-flex is-flex-direction-column gap-1"
          :class="screen === 'mobile' ? 'pt-0 mx-2' : ''"
        >
          <div
            class="columns is-shadowless has-margin-top-5 has-margin-left-5-mobile has-margin-right-5-mobile has-margin-bottom-5-mobile is-flex is-flex-direction-column"
          >
            <job-overview-for-employer
              v-if="$auth.loggedIn && $auth.user.employer_profile && showChart"
              class="mb-5"
            ></job-overview-for-employer>
            <similar-jobs
              v-if="
                !$auth.loggedIn ||
                ($auth.loggedIn && $auth.user.jobseeker_profile)
              "
            ></similar-jobs>
          </div>
          <dfp-slot
            id="div-gpt-ad-1715313076904-0"
            :path="'/35754210/RJP-SB1'"
            :size="[[250, 150]]"
          />
          <dfp-slot
            id="div-gpt-ad-1715313488682-0"
            :path="'/35754210/RJP-SB2'"
            :size="[[250, 150]]"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DfpSlot from '@/components/DfpSlot'
import JobDetail from '@/components/Jobseeker/JobDetail'
import SimilarJobs from '@/components/Job/Post/SimilarJobs.vue'
import { mapGetters } from 'vuex'
import JobOverviewForEmployer from '~/components/Job/JobOverviewForEmployer.vue'
export default {
  components: { JobDetail, SimilarJobs, JobOverviewForEmployer, DfpSlot },
  async asyncData({ params, store, $axios, route }) {
    const contentUrl = `/api/v1/job/search/${params.jobSlug}/`
    const { data } = await $axios.get(contentUrl)
    store.commit('collection/setCollectionData', ['jobDetails', data])
    store.commit('collection/setCollectionData', ['jobSearchCollection', data])
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({ screen: 'getScreen', showChart: 'getChart' }),
    titleJobData() {
      return this.get(this.$store.state.collection.collectionResponses, [
        'jobDetails'
      ])
    }
  },
  beforeDestroy() {
    this.$store.commit('setChart', false)
  },
  head() {
    return {
      title: `ROJGARI - ${
        this.titleJobData && this.titleJobData.job_title
          ? this.titleJobData.job_title
          : 'Job'
      } Jobs In Nepal - ${this.get(
        this.titleJobData,
        'organization.name',
        'A Reputed Organization'
      )}`
    }
  }
}
</script>

<style>
.rounded-10 {
  border-radius: 10px;
}
.bg-white {
  background-color: #fdfdfd;
}

.outline {
  border-style: solid;
  border-width: 1px;
  border-color: rgb(211, 209, 209);
}
</style>
